import { render, staticRenderFns } from "./productCatelog.html?vue&type=template&id=407306f6&scoped=true&"
import script from "./productCatelog.vue?vue&type=script&lang=js&"
export * from "./productCatelog.vue?vue&type=script&lang=js&"
import style0 from "./productCatelog.vue?vue&type=style&index=0&id=407306f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407306f6",
  null
  
)

export default component.exports